import React from "react";
import {ToggleButton} from "primereact/togglebutton";

const MonitoringQueueNav = (props: any) => {
    return (
        <div className="table-buttons">
            <div className="text-normal-weight flex align-items-center">
                <ToggleButton style={{fontWeight: 'normal'}} onLabel={'Мої активності'} offLabel={
                    props.countActiveCalls
                        ? `Активних дзвінків: ${props.countActiveCalls}`
                        : 'Немає активних дзвінків'
                } className="w-15rem mb-2 mr-2 font-normal"/>
            </div>
        </div>
    )
}

export default MonitoringQueueNav;
